/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown> }} Error_OverpaymentInputs */

const vi_error_overpayment = /** @type {(inputs: Error_OverpaymentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số tiền thu vượt số còn phải thu của đơn (còn ${i?.remaining} ₫).`)
};

/**

* @param {Error_OverpaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_overpayment = /** @type {((inputs: Error_OverpaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_OverpaymentInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_overpayment(inputs)
});